const scrollToLastMessage = (
  { selector = '#user-last-message', block = 'start' }: { selector?: string, block?: ScrollLogicalPosition}
) => {
  const lastUserMessage = document.querySelector(selector);
  if (!lastUserMessage) return;

  lastUserMessage.scrollIntoView({ block });
};

export default scrollToLastMessage;
